// extracted by mini-css-extract-plugin
var _1 = "RentalPortalArchiveTableRow-moduleRentalPortalArchiveTableRow__s1jvu TableComponent-modulerow__xPAo4";
export { _1 as "RentalPortalArchiveTableRow" }
